import {observer} from "mobx-react";
import {useCurrentRate} from "../../../infrastructure/hooks/rates/useCurrentRate";
import {OptionRate} from "./option-rate";

export const OptionCurrentRate = observer(({option, controller, className, betsImpressionParams}) => {
  const currentRate = useCurrentRate(controller, option);

  const optionRateProps = {
    controller,
    className,
    betsImpressionParams
  }

  return (
   <OptionRate {...optionRateProps}>
     {currentRate}
   </OptionRate>
  )
});